import { render } from "./PartnerPublicLoginRedirect.vue?vue&type=template&id=0be8f33c"
import script from "./PartnerPublicLoginRedirect.vue?vue&type=script&lang=js"
export * from "./PartnerPublicLoginRedirect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__